import {
  CONSUMER_CMS_SHOPPING_CART,
  errorMock,
  IPersonalInfoCmsMobile,
  IProduct,
  useCmsConfig,
  useGenerateOTP,
  useGetFindCaller,
  useVerifyOTP,
} from '@vfit/consumer/data-access';
import { useEnergyCheckout } from '../../../energy.context';
import { ICheckoutData } from '../../checkoutEnergy.models';
import TaggingOtpCard from './otpCard.tagging';
import { organizeOtp, Otp } from '@vfit/consumer/components';
import { API, resetData, trackView } from '@vfit/shared/data-access';
import { useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { getEnergyTrackError, getMsisdnForEnergy } from '../../checkoutEnergy.utils';

const OtpCard = ({ handleOnFinish }: ICheckoutData) => {
  const { findCaller, product, owningData, setFindCaller, setIsDisabledBackButton } =
    useEnergyCheckout();
  const queryClient = useQueryClient();
  const { mutate: generateOtp } = useGenerateOTP();
  const {
    mutate: mutateVerifyOtp,
    data: dataVerifyOtp,
    isSuccess: isSuccessVerifyOtp,
    isError: isErrorVerifyOtp,
    error: verifyOtpErrorData,
  } = useVerifyOTP();
  const {
    data: findcallerPostOtpData,
    error: findcallerPostOtpError,
    isError: isErrorFindcallerPostOtp,
    isSuccess: isSuccessFindcallerPostOtp,
    refetch: refetchFindcallerPostOtp,
  } = useGetFindCaller(
    { fiscalCode: owningData?.owningIndividual?.fiscalCode?.toUpperCase() },
    {
      enabled: false,
    }
  );

  const dataFromCms = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_PERSONAL_DATA_ENERGY
  ) as IPersonalInfoCmsMobile;

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSendOtp = (field: string, fieldType: string) => {
    resetData(queryClient, ['generateOTP']);
    generateOtp({
      identifier: field,
      identifierType: fieldType,
    });
  };

  const handleVerify = (otp: string) => {
    setIsLoading(true);
    mutateVerifyOtp(otp);
  };

  const handleSetError = () => {
    setIsError(false);
  };

  useEffect(() => {
    setIsDisabledBackButton(isLoading);
  }, [isLoading]);

  useEffect(() => {
    if (isErrorFindcallerPostOtp) {
      setIsError(true);
      setIsLoading(false);
      if (findcallerPostOtpError) {
        trackView({
          ...getEnergyTrackError(
            product,
            errorMock('FindCallerPostOtp', findcallerPostOtpError),
            'OTP'
          ),
          page_error_code: findcallerPostOtpError.status || '',
        });
      }
    } else if (isSuccessFindcallerPostOtp) {
      setIsLoading(false);
      setFindCaller({
        ...findcallerPostOtpData,
        isVerified: true,
        verifyOtp: dataVerifyOtp?.id || '',
      });
      resetData(queryClient, ['findCaller']);
      trackView({
        event_name: 'view',
        visitor_id_asset_active: getMsisdnForEnergy(findcallerPostOtpData),
      });
      setTimeout(() => {
        handleOnFinish?.();
      }, 1000);
    }
  }, [isErrorFindcallerPostOtp, isSuccessFindcallerPostOtp]);

  useEffect(() => {
    if (isErrorVerifyOtp) {
      setIsError(true);
      setIsLoading(false);
      if (verifyOtpErrorData) {
        trackView({
          ...getEnergyTrackError(product, errorMock('VerifyOtp', verifyOtpErrorData), 'OTP'),
          page_error_code: verifyOtpErrorData.status || '',
        });
      }
    } else if (isSuccessVerifyOtp) {
      refetchFindcallerPostOtp();
    }
  }, [isErrorVerifyOtp, isSuccessVerifyOtp]);

  useEffect(() => {
    if (findCaller.selectedContactMedium?.field)
      handleSendOtp(
        findCaller.selectedContactMedium.field,
        findCaller.selectedContactMedium.fieldType
      );
  }, []);

  return (
    <>
      <TaggingOtpCard />
      <Otp
        product={product as IProduct}
        contactMedium={findCaller.selectedContactMedium}
        isError={isError}
        isLoading={isLoading}
        reSendOtp={handleSendOtp}
        onVerify={handleVerify}
        setIsError={handleSetError}
        configOtp={organizeOtp(
          dataFromCms?.personalinfomobile,
          findCaller?.selectedContactMedium?.fieldType === 'msisdn',
          findCaller?.selectedContactMedium
        )}
      />
    </>
  );
};

export default OtpCard;
